import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/KEY_WORKER';

export const {action: init} = createAction(`${domain}/INIT`, () => ({}));
export const {
    action: searchEmployee,
    success: searchEmployeeSuccess,
    failed: searchEmployeeFailed,
    aborted: searchEmployeeAborted,
} = createAction(`${domain}/SEARCH_EMPLOYEE`, (institutionId, term) => ({institutionId, term}));
export const {
    action: searchSecondaryEmployee,
    success: searchSecondaryEmployeeSuccess,
    failed: searchSecondaryEmployeeFailed,
    aborted: searchSecondaryEmployeeAborted,
} = createAction(`${domain}/SEARCH_SECONDARY_EMPLOYEE`, (institutionId, term) => ({institutionId, term}));

export const {action: editing} = createAction(`${domain}/EDITING`, editing => ({editing}));
export const {
    action: save,
    success: saveSuccess,
    failed: saveFailed,
} = createAction(
    `${domain}/SAVE`,
    (childId, keyWorkers) => ({childId, keyWorkers}),
    (childId, keyWorkers) => ({childId, keyWorkers}),
);
